import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Iconify from '../../../components/iconify';
import AccountPopover from './AccountPopover';

const NAV_WIDTH = 280;
const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 72;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 4),
  },
}));

const pageTitles = {
  '/dashboard/user': 'Users',
  '/dashboard/events': 'News',
  '/dashboard/reservations': 'Reservations',
  '/dashboard/reservation-categories': 'Reservation Categories',
  '/dashboard/lanes': 'Lanes',
  '/dashboard/coupons': 'Cupones',
  '/dashboard/availability': 'Availability',
  '/dashboard/push-notifications': 'Push Notifications',
  '/dashboard/configuration': 'Configuration',
};

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const { pathname } = useLocation();
  const basePath = pathname.split('/').slice(0, 3).join('/');
  const pageTitle = pageTitles[basePath] || '';

  return (
    <StyledRoot>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Typography variant="h6" color="text.primary" sx={{ display: { xs: 'none', lg: 'block' } }}>
          {pageTitle}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={1}>
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
